import type * as Api from 'Api'
import type { OrderCustomer } from '@/models/'

export const orderFormErrorMessages: Dictionary<Dictionary<string>> = {
  lastName: {
    default: 'Допущена ошибка в фамилии',
    required: 'Введите фамилию',
  },
  firstName: {
    default: 'Допущена ошибка в имени',
    required: 'Введите имя',
  },
  middleName: {
    default: 'Допущена ошибка в отчестве',
    required: 'Введите отчество',
  },
  birthDate: {
    default: 'Допущена ошибка в дате рождения',
    required: 'Введите дату рождения',
    length: 'Дата рождения должна быть указана в формате ДД.ММ.ГГГГ',
    format: 'Дата рождения введена неверно',
  },
  cityName: {
    default: 'Допущена ошибка в названии города',
    required: 'Введите название города',
  },
  email: {
    default: 'Допущена ошибка в электронной почте',
    required: 'Введите свою электронную почту',
    email: 'Электронная почта введена неверно',
  },
  maxOrdersForEmail: {
    default: 'Количество заказов для данного e-mail превышено',
  },
  phoneNumber: {
    default: 'Допущена ошибка в номере телефона',
    required: 'Введите номер телефона',
    phone: 'Телефон должен быть указан в формате ',
  },
  paymentMethodId: {
    default: 'Допущена ошибка в способе доставки',
  },
  certificates: {
    default: 'Сертификат недействителен',
  },
  promotionApplication: {
    default: 'Промокод недействителен',
  },
  fanCode: {
    required: 'Введите FanID',
    fanCode: 'Введите корректный FanID',
  },
  sectorPassword: {
    required: 'Введите промокод',
    default: 'Неверный промокод',
  },
}

export const orderErrorHandbook: Api.ErrorsHandbook<
  keyof Omit<OrderCustomer, 'fullName' | 'subscribeToNews' | 'additionalFields'>
> = {
  firstName: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.firstName.default,
    },
  ],
  lastName: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.lastName.default,
    },
  ],
  middleName: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.middleName.default,
    },
  ],
  birthDate: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.birthDate.default,
    },
  ],
  email: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.email.default,
    },
  ],
  phoneNumber: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.phoneNumber.default,
    },
  ],
  cityName: [
    {
      status: 1,
      code: 400,
      message: orderFormErrorMessages.cityName.default,
    },
  ],
}
